import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ReservationsService } from 'src/app/services/reservations.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-assign-confirm-overlap',
  templateUrl: './assign-confirm-overlap.component.html',
  styleUrls: ['./assign-confirm-overlap.component.scss']
})
export class AssignConfirmOverlapComponent implements OnInit {

  @Input() dialogData: any
  public event: EventEmitter<any> = new EventEmitter();


  constructor(public bsModalRef: BsModalRef,
    private spinner: NgxSpinnerService,
    private notifier: NotifierService,
    private reservationsService: ReservationsService) { }

  ngOnInit() { }

  cancelGreet() {
    this.spinner.show()
    this.reservationsService.assignGreetForOverLapedSlot(this.dialogData).subscribe(res => {
      this.spinner.hide();
     
    //  setTimeout(() => {
        if (res['status']) {
          this.notifier.notify('success', res['message'])
          this.bsModalRef.hide();
          this.triggerEvent(true);
        } else {
          this.notifier.notify('danger', res['message'])
          this.bsModalRef.hide();
          this.triggerEvent(false);
        }
    //  }, 1000);

    })
  }

  triggerEvent(item) {
    this.event.emit({ data: item, res: 200 });
  }

  closeModal() {
    this.bsModalRef.hide()
    this.triggerEvent(false);
  }

}
